import { render, staticRenderFns } from "./user-dialog.vue?vue&type=template&id=258fd978&scoped=true"
import script from "./user-dialog.vue?vue&type=script&lang=js"
export * from "./user-dialog.vue?vue&type=script&lang=js"
import style0 from "./user-dialog.vue?vue&type=style&index=0&id=258fd978&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258fd978",
  null
  
)

export default component.exports